module.exports = __webpack_public_path__ + "public/static/img/recover-password-page-img-01-dark.64bb07f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recover-password-page-img-01-dark.svg
// module id = oapx
// module chunks = 1